import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.scss';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem('cookie_consent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Consenso cookie">
      <div className="cookie-banner__content">
        <p className="cookie-banner__text">
          Questo sito utilizza cookie tecnici necessari al funzionamento.
          Per maggiori informazioni consulta la nostra{' '}
          <Link to="/cookie-policy">Cookie Policy</Link>.
        </p>
        <div className="cookie-banner__actions">
          <button className="cookie-banner__btn cookie-banner__btn--reject" onClick={reject}>
            Rifiuta
          </button>
          <button className="cookie-banner__btn cookie-banner__btn--accept" onClick={accept}>
            Accetta
          </button>
        </div>
      </div>
    </div>
  );
};

export const openCookieBanner = () => {
  localStorage.removeItem('cookie_consent');
  window.dispatchEvent(new Event('storage'));
};

export default CookieBanner;
